import type { StockListResponseType } from "@sellar-io/api-v2/types";
import { Card, DataButton } from "@sellar-io/components";
import { useSortable } from "@dnd-kit/react/sortable";
import type { ReactElement } from "react";
import { CircularImage, Icon } from "../../../../../components";
import { generateCategoryName } from "../../CategoryListElement/CategoryListElementContainer.shared";

export const SortableProductListItem = ({
  product,
  onMove,
  index,
  disabled,
}: {
  product: StockListResponseType[number];
  onMove: () => void;
  index: number;
  disabled: boolean;
}): ReactElement => {
  const { ref, handleRef, isDragging } = useSortable({
    id: product.id,
    index,
  });

  return (
    <>
      <div
        ref={ref}
        className={isDragging ? "relative z-50 opacity-50" : "relative"}
      >
        <Card className="flex min-w-0 items-center gap-4 border border-zinc-200 bg-white p-4">
          <button
            ref={handleRef}
            type="button"
            disabled={disabled}
            className={disabled ? "cursor-wait opacity-50" : "cursor-grab"}
            aria-label={`Reorder ${product.name}`}
          >
            <Icon icon="MENU" />
          </button>
          {product.imageUrl && (
            <CircularImage src={product.imageUrl} alt="" size={48} />
          )}
          <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
            <span className="truncate font-semibold">{product.name}</span>
            <span className="truncate text-sm text-zinc-700">
              {generateCategoryName(product, true)}
            </span>
          </div>
          <DataButton
            border={true}
            disabled={disabled}
            aria-label={`Move ${product.name ?? "product"} to another group`}
            onClick={onMove}
          >
            Move
          </DataButton>
        </Card>
      </div>
    </>
  );
};
